import React from 'react';
import { List } from 'semantic-ui-react';
import { TIME_FRAME_TYPES } from '../Constants';
import { TimeFrameOption } from '../Util';

type TimeRangeQuickProps = {
  timeFrames: TimeFrameOption[];
  selectTimeFrame(timeFrame: TIME_FRAME_TYPES): void;
};

export function TimeRangeQuick(props: TimeRangeQuickProps) {
  const { selectTimeFrame, timeFrames } = props;
  return (
    <List divided verticalAlign="middle" size="big">
      {timeFrames.map((timeFrameOption) => (
        <List.Item
          key={timeFrameOption.timeFrame}
          onClick={() => selectTimeFrame(timeFrameOption.timeFrame)}
        >
          <List.Content>
            <List.Header as="a">{timeFrameOption.name}</List.Header>
          </List.Content>
        </List.Item>
      ))}
    </List>
  );
}
